export default __webpack_public_path__ + "static/media/other.7a2e23d3.png";